"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Pinterest;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Pinterest(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("title", null, "Pinterest"), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Social_media",
    "data-name": "Social media"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M51.8,12.5c-15.417,0-30.654,10.278-30.654,26.913C21.149,49.992,27.1,56,30.706,56c1.487,0,2.344-4.148,2.344-5.32,0-1.4-3.562-4.373-3.562-10.188,0-12.082,9.2-20.647,21.1-20.647,10.233,0,17.807,5.815,17.807,16.5,0,7.979-3.2,22.946-13.569,22.946a6.673,6.673,0,0,1-6.943-6.582c0-5.68,3.967-11.18,3.967-17.041,0-9.947-14.11-8.144-14.11,3.877a17.654,17.654,0,0,0,1.443,7.619c-2.074,8.926-6.312,22.225-6.312,31.421,0,2.84.406,5.635.677,8.475.511.571.255.511,1.036.225,7.574-10.368,7.3-12.4,10.73-25.966,1.848,3.516,6.626,5.41,10.413,5.41,15.959,0,23.126-15.553,23.126-29.573C78.851,22.237,65.958,12.5,51.8,12.5Z"
  })));
}